import GoExternal from '@clearkit/icons/glyphs/GoExternal';
import Lock from '@clearkit/icons/glyphs/Lock';
import { CKBox, CKButton, CKTag, CKTooltip } from 'clearkit';
import { Link } from 'react-router-dom';

const Variants = Object.freeze({
  default: 'default',
  external: 'external',
  comingSoon: 'comingSoon',
});

const EnrichmentCard = ({
  Icon,
  bgClass,
  iconFillOverride,
  title,
  text,
  tag,
  hasAccess,
  hasPermission,
  variant = Variants.default,
  url,
  setShowUpgradeForm = () => {},
}) => {
  return (
    <div className="mb-6 mr-6">
      <CKBox variant={CKBox.Variant.card} className="p-6 w-84 h-86">
        <CKBox
          {...(!bgClass && { variant: CKBox.Variant['tinted-frame'] })}
          className={`flex items-center justify-center h-32 p-6 ${bgClass}`}>
          {Icon && (
            <Icon
              height="63"
              width="63"
              className={`${iconFillOverride || 'text-white'} fill-current`}
            />
          )}
        </CKBox>
        <div className="flex flex-row justify-between mt-6">
          <p className="text-base font-semibold text-black">{title}</p>
          <CKTag className="text-gray-500 bg-gray-100">{tag}</CKTag>
        </div>
        <p className="mt-3 text-base text-gray-600 min-h-16">{text}</p>
        {(() => {
          if (!hasAccess) {
            return (
              <CKButton
                onClick={() => setShowUpgradeForm(true)}
                className="w-full mt-8 min-h-9">
                Request access
              </CKButton>
            );
          }

          if (!hasPermission) {
            return (
              <CKTooltip
                targetClassName="w-full"
                placement="bottom"
                tooltip="You don't have permission to access this feature. Contact
                    your team Admin for access.">
                <CKButton
                  className="w-full mt-8 min-h-9"
                  isDisabled
                  onClick={() => {}}
                  leftIcon={<Lock />}>
                  Unlock {title}
                </CKButton>
              </CKTooltip>
            );
          }

          switch (variant) {
            case Variants.external:
              return (
                <CKButton
                  as="a"
                  className="w-full mt-8 min-h-9"
                  href={`https://${url}/`}
                  rightIcon={<GoExternal />}>
                  Go to {url}
                </CKButton>
              );
            case Variants.default:
              return (
                <CKButton as={Link} to={url} className="w-full mt-8 min-h-9">
                  Configure
                </CKButton>
              );
            case Variants.comingSoon:
              return (
                <CKButton
                  as={Link}
                  isDisabled
                  className="w-full mt-8 min-h-9"
                  to={url}>
                  Coming soon
                </CKButton>
              );
          }
        })()}
      </CKBox>
    </div>
  );
};

EnrichmentCard.propTypes = {
  Icon: PropTypes.func,
  bgClass: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  tag: PropTypes.string,
  hasAccess: PropTypes.bool,
  hasPermission: PropTypes.bool,
  external: PropTypes.bool,
  url: PropTypes.string,
};

EnrichmentCard.Variants = Variants;

export default EnrichmentCard;
